// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataCollapseTable_wrapper__1ysmj","nameCell":"DataCollapseTable_nameCell___5kC4"};